import { ReactElement } from 'react'
import { Link } from '../../../../../ui-components/util/Interfaces'
import styled from 'styled-components'
import { MessageInfo } from './interfaces'
import { defaultTheme } from '../../../../../theme'

interface MessageItemProps {
  item: MessageInfo
  hideLink?: boolean
}

const handleClick = (link: Link) => {
  link.action()
}

export const MessageItem = (props: MessageItemProps): ReactElement => {
  const { item, hideLink } = props
  return (
    <StyledText>
      <StyledAction onClick={() => handleClick(item.link)} hideLink={hideLink}>
        {item.link.text}
      </StyledAction>
      {item.message}
    </StyledText>
  )
}

const StyledText = styled.div`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  max-width: 100%;
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
`

interface StyledActionProps {
  hideLink?: boolean
}

const StyledAction = styled.span<StyledActionProps>`
  padding-right: 0.3rem;
  text-decoration: ${(p) => (p.hideLink ? 'none' : 'underline')};
  align-content: end;
  cursor: ${(p) => (p.hideLink ? 'none' : 'pointer')};
  color: ${(p) =>
    p.hideLink ? defaultTheme.colors.almostBlack : defaultTheme.colors.link};
  overflow-wrap: anywhere;
  word-break: break-word;
`
